export interface Config {

  // 常量配置
  constants: {
    MAX_FILE_SIZE: number;
    SUPPORTED_FILE_TYPES: string[];
    DEFAULT_CURRENCY: string;
    DEFAULT_SHIP_TO: string;
  };

  // 服务配置
  services: {
    // Shopify 服务
    shopify: {
      apiHost: string;
    };
    // 搜索服务
    search: {
      apiHost: string;
      apiKey: string;
    };
    // 认证服务
    auth: {
      apiHost: string;
    };
    // LLM 服务
    llm: {
      apiHost: string;
      apiKey: string;
    };
    // 支付服务
    billing: {
      apiHost: string;
    };
    agent: {
      apiHost: string;
      apiKey: string;
    };
    feature: {
      apiHost: string;
    };
  };
}

const accountApiHost = import.meta.env.VITE_ACCOUNT_API_HOST
    || import.meta.env.VITE_OAUTH_HOST
    || import.meta.env.VITE_API_HOST;

const config: Config = {

    // 常量配置
    constants: {
        MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
        SUPPORTED_FILE_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
        DEFAULT_CURRENCY: 'USD',
        DEFAULT_SHIP_TO: 'US'
    },

    // 服务配置
    services: {
    // Shopify 服务
        shopify: {apiHost: import.meta.env.VITE_SHOPIFY_PROXY_HOST,},
        // 搜索服务
        search: {
            apiHost: import.meta.env.VITE_API_HOST,
            apiKey: import.meta.env.VITE_API_KEY,
        },
        // 认证服务
        auth: {apiHost: accountApiHost,},
        // LLM 服务
        llm: {
            apiHost: import.meta.env.VITE_LLM_API_HOST,
            apiKey: import.meta.env.VITE_LLM_API_KEY,
        },
        // 支付服务
        billing: {apiHost: accountApiHost,},
        agent: {
            apiHost: import.meta.env.VITE_API_HOST,
            apiKey: import.meta.env.VITE_API_KEY,
        },
        feature: {apiHost: accountApiHost,},
    },
};

export default config;

export * from './pricingCatalog';
